import axios from "axios";
import { getToken } from "../../Utlis/UpdateUserState";

const getFleetManagers = async () => {
  try {
    const token = getToken();

    const res = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}admin/fleet-managers/`,
      {
        headers: { Authorization: `Bearer ${token}` },
      },
    );

    return res;
  } catch (error) {
    console.error("Fleet managers fetch error:", error);
    throw error;
  }
};

const getFleetManagerById = async (id) => {
  try {
    const token = getToken();

    const res = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}admin/fleet-managers/?id=${id}`,
      {
        headers: { Authorization: `Bearer ${token}` },
      },
    );

    return res;
  } catch (error) {
    console.error("Fleet manager fetch error:", error);
    throw error;
  }
};

const updateFleetManager = async (id, data) => {
  try {
    const token = getToken();

    const res = await axios.patch(
      `${process.env.REACT_APP_BACKEND_URL}admin/fleet-managers/?id=${id}`,
      data,
      {
        headers: { Authorization: `Bearer ${token}` },
      },
    );

    return res;
  } catch (error) {
    console.error("Fleet manager update error:", error);
    throw error;
  }
};

const updateFleetCompanyFuelingStatus = async (companyId, data) => {
  try {
    const token = getToken();

    const res = await axios.patch(
      `${process.env.REACT_APP_BACKEND_URL}admin/fleet-companies/fueling-status/?company_id=${companyId}`,
      data,
      {
        headers: { Authorization: `Bearer ${token}` },
      },
    );

    return res;
  } catch (error) {
    console.error("Fleet company fueling status update error:", error);
    throw error;
  }
};

const loginAsFleetManager = async (id) => {
  try {
    const token = getToken();

    const res = await axios.post(
      `${process.env.REACT_APP_BACKEND_URL}admin/fleet-managers/login-as/?id=${id}`,
      {},
      {
        headers: { Authorization: `Bearer ${token}` },
      },
    );

    return res;
  } catch (error) {
    console.error("Login as fleet manager error:", error);
    throw error;
  }
};

export {
  getFleetManagers,
  getFleetManagerById,
  updateFleetManager,
  updateFleetCompanyFuelingStatus,
  loginAsFleetManager,
};
